import { getCleanUrl } from '@theme/js/utils/url.util';

import * as Types from '@theme/js/components/main/BreadcrumbList/types';

export const findPathByCleanUrl = (
    cleanUrl: string,
    items: Types.IMenuItem[]
): Types.IMenuItem[] | null => {
    for (const item of items) {
        if (getCleanUrl(item.friendlyURL) === cleanUrl) {
            return [item];
        } else if (item.children) {
            const pathInChild = findPathByCleanUrl(cleanUrl, item.children);
            if (pathInChild) {
                return [item, ...pathInChild];
            }
        }
    }
    return null;
};
